import VuexPersist from 'vuex-persist'

const vuexPersist = new VuexPersist({
  key: 'Iconn',
  storage: window.localStorage
})

let store = {
    plugins: [vuexPersist.plugin],

    state: {
        activityUuid: null,
        termsLink: null,
        emailMandatoryOnOrder: null,
        minimumOrder: null,
        cart: [],
        cartRestaurant: null,
        isShop: null,
        charges: null,
        cartNote: null,
        serviceTypeForm: {},
        cartEmail: null,
        previewableCartItem: null,
        cartCount: 0,
        cartTotal: 0,
        showCart: false,
        sendingOrder: false,
        showOrderConfirmation: false,
        showDeliveryDetails: false,
        showOrderEmailConfirmation: false,
        cartLanguages: [],
        defaultCartLanguage: null,
        defaultCartLanguageCode: null,
        isOtherRestaurantModalVisible: false,
        deliveryDetails: {
            name: null,
            phone: null,
            email: null,
            street: null,
            city: null,
            zip: null,
            province: null,
            country: null,
        }
    },

    getters: {
        previewableCartItem: state => state.previewableCartItem,
        previewableCartItemFromCart: state => (state.previewableCartItem !== null && state.previewableCartItem.item) ? state.cart.find((el) => el.item.uuid === state.previewableCartItem.item.uuid) : false,
        cartCount: state => state.cart.reduce((prev, cur) => prev + cur.qty, 0),
        cartTotal: state => state.cart.reduce((prev, cur) => prev + (cur.qty * cur.price), 0),
        cart: state => state.cart,
        cartUuids: state => state.cart.map((item) => item.item.uuid),
        showCart: state => state.showCart,
        cartRestaurant: state => state.cartRestaurant,
        cartNote: state => state.cartNote,
        serviceTypeForm: state => state.serviceTypeForm,
        cartEmail: state => state.cartEmail,
        activityUuid: state => state.activityUuid,
        termsLink: state => state.termsLink,
        emailMandatoryOnOrder: state => state.emailMandatoryOnOrder,
        minimumOrder: state => state.minimumOrder,
        sendingOrder: state => state.sendingOrder,
        showOrderConfirmation: state => state.showOrderConfirmation,
        showDeliveryDetails: state => state.showDeliveryDetails,
        showOrderEmailConfirmation: state => state.showOrderEmailConfirmation,
        cartLanguages: state => state.cartLanguages,
        defaultCartLanguage: state => state.defaultCartLanguage,
        defaultCartLanguageCode: state => state.defaultCartLanguageCode,
        isOtherRestaurantModalVisible: state => state.isOtherRestaurantModalVisible,
        deliveryDetails: state => state.deliveryDetails,
    },

    actions: {
        showOtherRestaurantModal({ commit }){
           commit('SHOW_OTHER_RESTAURANT_MODAL')
        },

        hideOtherRestaurantModal({ commit }){
           commit('HIDE_OTHER_RESTAURANT_MODAL')
        },

        setCartLanguages({ commit }, cartLanguages){
           commit('SET_CART_LANGUAGES', cartLanguages)
        },

        setDefaultCartLanguage({ commit }, defaultCartLanguage){
          // console.log(defaultCartLanguage)
           commit('SET_DEFAULT_CART_LANGUAGE', defaultCartLanguage)
        },

        setDefaultCartLanguageCode({ commit }, defaultCartLanguageCode){
          // console.log(defaultCartLanguage)
           commit('SET_DEFAULT_CART_LANGUAGE_CODE', defaultCartLanguageCode)
        },

        setActivityUuid ({ commit }, uuid) {
          commit('SET_ACTIVITY_UUID', uuid)
        },

        setTermsLink ({ commit }, link) {
          commit('SET_TERMS_LINK', link)
        },

        setEmailMandatoryOnOrder ({ commit }, value) {
            if(value === "1") {
              commit('SET_EMAIL_MANDATORY_ON_ORDER', true)
            } else {
              commit('SET_EMAIL_MANDATORY_ON_ORDER', false)
            }
        },

        setMinimumOrder ({ commit }, value) {
          commit('SET_MINIMUM_ORDER', value)
        },

        setPreviewableCartItem ({ commit }, item) {
          if(item.price.length) {
            commit('SET_PREVIEWABLE_CART_ITEM', item)
          }
        },

        closeAllOverLays ({commit}) {
          commit('REMOVE_PREVIEWABLE_CART_ITEM')
          commit('CLOSE_CART')
          commit('HIDE_ORDER_CONFIRMATION')
          commit('HIDE_DELIVERY_DETAILS')
          commit('HIDE_ORDER_EMAIL_CONFIRMATION')
        },

        removePreviewableCartItem ({ commit }) {
          commit('REMOVE_PREVIEWABLE_CART_ITEM')
        },

        addWithQtyToCart ({ commit }, payload) {
          commit('ADD_WITH_QTY_TO_CART', payload)
        },

        addOneToCart ({ commit }, item) {
          commit('ADD_ONE_TO_CART', item)
        },

        removeOneFromCart ({ commit }, item) {
          commit('REMOVE_ONE_FROM_CART', item)
        },

        emptyCart ({ commit }) {
          commit('EMPTY_CART')
        },

        openCart ({ commit }) {
          commit('OPEN_CART')
        },

        closeCart ({ commit }) {
          commit('CLOSE_CART')
        },

        setCartNote ({ commit }, note) {
          commit('SET_CART_NOTE', note)
        },

        setServiceTypeForm ({ commit }, serviceTypeForm) {
          commit('SET_SERVICE_TYPE_FORM', serviceTypeForm)
        },

        setCartEmail ({ commit }, email) {
          commit('SET_CART_EMAIL', email)
        },

        showOrderConfirmation ({ commit }) {
          commit('SHOW_ORDER_CONFIRMATION')
        },
        hideOrderConfirmation ({ commit }) {
          commit('HIDE_ORDER_CONFIRMATION')
        },

        showDeliveryDetails ({ commit }) {
          commit('SHOW_DELIVERY_DETAILS')
        },

        hideDeliveryDetails ({ commit }) {
          commit('HIDE_DELIVERY_DETAILS')
        },

        setDeliveryDetails ({ commit }) {
          commit('SET_DELIVERY_DETAILS')
        },

        showOrderEmailConfirmation ({ commit }) {
          commit('SHOW_ORDER_EMAIL_CONFIRMATION')
        },
        hideOrderEmailConfirmation ({ commit }) {
          commit('HIDE_ORDER_EMAIL_CONFIRMATION')
        },

        sendOrder ({commit, getters}, goStraightToFinalScreen = false) {
          if(getters.sendingOrder) {
              //
            console.log('blocked sendingOrder')
            // commit('SET_SENDING_ORDER', false)
          } else {
            commit('SET_SENDING_ORDER', true)
            window.axios.post(`/${getters.activityUuid}/order`, {
              restaurant: getters.cartRestaurant,
              cart: getters.cart,
              note: getters.cartNote,
              email: getters.cartEmail,
              language: getters.defaultCartLanguageCode,
              deliveryDetails: getters.deliveryDetails,
              serviceTypeAdditionalData: JSON.stringify(getters.serviceTypeForm)
            }).then((response) => {
              commit('SET_SENDING_ORDER', false)
              commit('SET_CART_NOTE', null)
              commit('SET_CART_EMAIL', null)
              commit('CLOSE_CART')
              commit('EMPTY_CART')
              commit('EMPTY_CART_RESTAURANT')
              commit('HIDE_DELIVERY_DETAILS')
              commit('EMPTY_DELIVERY_DETAILS')
              if (goStraightToFinalScreen) {
                commit('SHOW_ORDER_EMAIL_CONFIRMATION')
              } else {
                commit('SHOW_ORDER_CONFIRMATION')
              }
            }).catch((err) => {
              commit('SET_SENDING_ORDER', false)
              console.log(err)
            })
          }
        },


        updateLatestOrderWithEmail ({commit, getters}, email) {
          window.axios.post(`/${getters.activityUuid}/order-email`, {
            email: email,
          }).then((response) => {
            commit('HIDE_ORDER_CONFIRMATION')
            commit('SHOW_ORDER_EMAIL_CONFIRMATION')
          }).catch((err) => {
            console.log(err)
          })
        }
      },

    mutations: {
        SHOW_OTHER_RESTAURANT_MODAL (state) {
          state.isOtherRestaurantModalVisible = true
        },

        HIDE_OTHER_RESTAURANT_MODAL (state) {
          state.isOtherRestaurantModalVisible = false
        },

        SET_CART_LANGUAGES (state, cartLanguages) {
          state.cartLanguages = cartLanguages
        },

        SET_DEFAULT_CART_LANGUAGE (state, defaultCartLanguage) {
          state.defaultCartLanguage = defaultCartLanguage
        },

        SET_DEFAULT_CART_LANGUAGE_CODE (state, defaultCartLanguageCode) {
          state.defaultCartLanguageCode = defaultCartLanguageCode
        },

        SET_ACTIVITY_UUID (state, uuid) {
          state.activityUuid = uuid
        },

        SET_TERMS_LINK (state, link) {
          state.termsLink = link
        },

        SET_SENDING_ORDER (state, value) {
          state.sendingOrder = value
        },

        SET_EMAIL_MANDATORY_ON_ORDER (state, value) {
          state.emailMandatoryOnOrder = value
        },

        SET_MINIMUM_ORDER (state, value) {
          state.minimumOrder = value
        },

        OPEN_CART (state) {
          state.showCart = true
        },

        CLOSE_CART (state) {
          state.showCart = false
        },

        SET_PREVIEWABLE_CART_ITEM (state, item) {
            state.previewableCartItem = {
                item: item,
                qty: 1,
                price: item.price,
            }
        },

        REMOVE_PREVIEWABLE_CART_ITEM (state) {
            state.previewableCartItem = null
        },

        ADD_WITH_QTY_TO_CART (state, payload) {
          if (state.cartRestaurant && (state.cartRestaurant.uuid !== payload.item.restaurant.uuid)){
            state.cart = []
          }

          state.cartRestaurant = payload.item.restaurant

          state.cart.push({
              item: payload.item,
              qty: payload.qty,
              price: payload.item.price,
          });
        },

        ADD_ONE_TO_CART (state, item) {
          var itemInCart = state.cart.find((el) => el.item.uuid === item.uuid)

          if(itemInCart) {
              itemInCart.qty++;
          } else {
              state.cart.push({
                  item: item,
                  qty: 1,
                  price: item.price,
              });
          }
        },

        REMOVE_ONE_FROM_CART (state, item) {
          var itemInCart = state.cart.find((el) => el.item.uuid === item.uuid)

          if(itemInCart) {
              if(itemInCart.qty > 1){
                  itemInCart.qty--;
              } else if(itemInCart.qty == 1){
                  state.cart = state.cart.filter(( cartItem ) => cartItem.item.uuid !== item.uuid)

                  if(state.cart.length === 0) {
                    state.cartRestaurant = null
                    state.previewableCartItem = null
                  }
              }
          }
        },

        EMPTY_CART(state) {
           state.cart = []
           state.cartRestaurant = null
        },

        EMPTY_CART_RESTAURANT(state) {
           state.cartRestaurant = null
        },

        SHOW_ORDER_CONFIRMATION (state) {
          state.showOrderConfirmation = true
        },

        HIDE_ORDER_CONFIRMATION (state) {
          state.showOrderConfirmation = false
        },

        SHOW_DELIVERY_DETAILS (state) {
          state.showDeliveryDetails = true
        },

        HIDE_DELIVERY_DETAILS (state) {
          state.showDeliveryDetails = false
        },

        SET_DELIVERY_DETAILS (state) {
          state.deliveryDetails = false
        },

        EMPTY_DELIVERY_DETAILS (state) {
          state.deliveryDetails = {
              name: null,
              phone: null,
              email: null,
              street: null,
              city: null,
              zip: null,
              province: null,
              country: null,
          }
        },

        SHOW_ORDER_EMAIL_CONFIRMATION (state) {
          state.showOrderEmailConfirmation = true
        },

        HIDE_ORDER_EMAIL_CONFIRMATION (state) {
          state.showOrderEmailConfirmation = false
        },

        SET_CART_NOTE(state, note) {
           state.cartNote = note
        },

        SET_SERVICE_TYPE_FORM(state, serviceTypeForm) {
           state.serviceTypeForm = serviceTypeForm
        },

        SET_CART_EMAIL(state, email) {
           state.cartEmail = email
        }
    }
};

export default store;
